import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import Button from '@plasma/ui.general.button';

import { ShoppingCartTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ShoppingCartTheme>;
const css = baseCss as ThemedCssFunction<ShoppingCartTheme>;

export const ShoppingCart = styled.div`
  width: 100%;
  height: 100%;
`;

export const NormalPlasmaButton = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.mode.shoppingCart.normalButtonBGColor} !important;
    border: ${theme.mode.shoppingCart.normalButtonBorderColor} !important;
  `}
`;
